var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebitCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8604 26.2943L34.1789 21.118M20.355 29.6287L20.3657 29.6258M24.648 28.4784L26.7945 27.9032M14.3797 24.5005C14.1885 23.7868 14.3443 23.0115 14.8129 22.3451C15.2815 21.6787 16.0245 21.1758 16.8784 20.947L29.7575 17.496C30.6114 17.2672 31.5063 17.3313 32.2453 17.6741C32.9844 18.0169 33.507 18.6105 33.6982 19.3241L35.6209 26.4996C35.8121 27.2132 35.6562 27.9885 35.1876 28.6549C34.719 29.3213 33.976 29.8243 33.1221 30.0531L20.2431 33.504C19.3892 33.7328 18.4942 33.6688 17.7552 33.3259C17.0162 32.9831 16.4936 32.3896 16.3023 31.6759L14.3797 24.5005Z",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.7857C14 23.0469 14.3512 22.3383 14.9763 21.8159C15.6014 21.2935 16.4493 21 17.3333 21H30.6667C31.5507 21 32.3986 21.2935 33.0237 21.8159C33.6488 22.3383 34 23.0469 34 23.7857V31.2143C34 31.9531 33.6488 32.6617 33.0237 33.1841C32.3986 33.7065 31.5507 34 30.6667 34H17.3333C16.4493 34 15.6014 33.7065 14.9763 33.1841C14.3512 32.6617 14 31.9531 14 31.2143V23.7857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6429H34H14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4444 30.2857H18.4556H18.4444Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8889 30.2857H25.1111H22.8889Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6429H34M18.4444 30.2857H18.4556M22.8889 30.2857H25.1111M14 23.7857C14 23.0469 14.3512 22.3383 14.9763 21.8159C15.6014 21.2935 16.4493 21 17.3333 21H30.6667C31.5507 21 32.3986 21.2935 33.0237 21.8159C33.6488 22.3383 34 23.0469 34 23.7857V31.2143C34 31.9531 33.6488 32.6617 33.0237 33.1841C32.3986 33.7065 31.5507 34 30.6667 34H17.3333C16.4493 34 15.6014 33.7065 14.9763 33.1841C14.3512 32.6617 14 31.9531 14 31.2143V23.7857Z",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/DebitCard.a759aef50c33bd41fc07c29346452d9c.svg";
export { ForwardRef as ReactComponent };